import gql from 'graphql-tag';

import {graphql} from "../../../../actions";

export default (name, variables) => graphql(name, 'analysis', gql`query Analysis(
    $client: Int!
    $from: String!
    $to: String!
) {
    analysis(
        client: $client,
        from: $from,
        to: $to,
        field: "COUNT(a.id)",
        buckets: [
            {
                bucket: "(SELECT author AS id FROM articles WHERE monitoring_date >= \\"${variables.from}\\" AND monitoring_date <= \\"${variables.to}\\" AND author IS NOT NULL AND author <> '' GROUP BY author ORDER BY COUNT(*) DESC LIMIT 10)", 
                field: "a.author"
            }
        ]
    ) {
        keys
        count
    }
}`, variables)
